'use strict';

function AddressBookService($resource, config) {
  return $resource(config.apiBase + '/addressbook/:id', { id: '@id' }, {
    'query': {
      method: 'GET',
      isArray: true
    },
    'insert': {
      method: 'POST',
      transformResponse: [function(response, headers) {
        return {
          id: headers('Location').split('/').pop()
        };
      }]
    },
    'update': {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    }
  });
}

angular.module('dokiv')
  .factory('AddressBookService', [
    '$resource',
    'config',
    AddressBookService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/AddressBookService.js
// module id = 306
// module chunks = 0